import { Link } from 'react-router-dom'
import { Reveal } from '../../../components/Reveal.jsx'
import { EyebrowLabel } from '../../../components/EyebrowLabel.jsx'
import { useModals } from '../../../contexts/ModalContext.jsx'

const CARDS = [
  {
    to: '/weight-loss',
    badge: 'Most Popular',
    badgeClass: 'bg-[#EDF7F7] text-teal-600',
    iconBg: 'bg-[#E0F2F2] text-teal-600',
    name: 'Weight Loss',
    desc: 'Provider-guided weight loss with ongoing labs and real clinical support — not just a prescription.',
    cta: 'Explore options',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M12 3v18M8 7h7.5a3.5 3.5 0 0 1 0 7H9.5a3.5 3.5 0 0 0 0 7H17" />
      </svg>
    ),
  },
  {
    to: '/peptides',
    badge: 'Advanced',
    badgeClass: 'bg-[#F7FAE8] text-leaf-600',
    iconBg: 'bg-[#EEF4DC] text-leaf-600',
    name: 'Peptides',
    desc: 'Recover faster and train harder — prescription peptide protocols from a licensed pharmacy (may support recovery; results vary).',
    cta: 'Explore peptides',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M12 3l7 4v9l-7 4-7-4V7l7-4Z" />
        <circle cx="12" cy="11.5" r="1.7" />
      </svg>
    ),
  },
  {
    to: '/mens-health',
    badge: "Men's Hormones",
    badgeClass: 'bg-[#EDF7F7] text-teal-600',
    iconBg: 'bg-[#E0F2F2] text-teal-600',
    name: "Men's Hormones",
    desc: 'Get your edge back — clinically supervised hormone care for energy, focus, and drive, with real labs and provider check-ins.',
    cta: 'Explore options',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M13 2 5 13.5h5L9 22l8-11.5h-5L13 2Z" />
      </svg>
    ),
  },
  {
    to: '/womens-hormones',
    badge: "Women's Health",
    badgeClass: 'bg-[#F5E9F0] text-plum-600',
    iconBg: 'bg-[#F5E9F0] text-plum-600',
    name: "Women's Hormones",
    desc: 'Feel like yourself again — bioidentical HRT for perimenopause, menopause, and balance, built around your labs.',
    cta: 'Explore options',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M12 21v-6" />
        <path d="M12 15c-4 0-6.5-2.8-6.5-6.5C7.8 8.5 10 9.6 12 12c2-2.4 4.2-3.5 6.5-3.5C18.5 12.2 16 15 12 15Z" />
      </svg>
    ),
  },
  {
    to: '/wellness',
    badge: 'Wellness',
    badgeClass: 'bg-[#F7FAE8] text-leaf-600',
    iconBg: 'bg-[#F6F9DA] text-leaf-600',
    name: 'Wellness',
    desc: 'Add life to your years — NAD+ and evidence-informed healthy-aging protocols, prescribed at provider discretion.',
    cta: 'Explore protocols',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
      </svg>
    ),
  },
  {
    to: '/recovery',
    badge: 'Recovery',
    badgeClass: 'bg-[#F7FAE8] text-leaf-600',
    iconBg: 'bg-[#EEF4DC] text-leaf-600',
    name: 'Recovery',
    desc: 'Support tissue repair, joint recovery, and bounce-back — prescription recovery protocols with real clinical oversight.',
    cta: 'Explore recovery',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M4 12h4l2-6 4 12 2-6h4" />
      </svg>
    ),
  },
  {
    to: '/labs',
    badge: 'New',
    badgeClass: 'bg-[#EDF7F7] text-teal-700',
    iconBg: 'bg-[#E0F2F2] text-[#29A19C]',
    name: 'Labs',
    desc: 'Know your numbers — comprehensive at-home and walk-in panels, physician-ordered and physician-reviewed.',
    cta: 'See panels',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M9.5 3h5M10.5 3v7.5L6 18.2A2.6 2.6 0 0 0 8.4 22h7.2a2.6 2.6 0 0 0 2.4-3.8L13.5 10.5V3" />
        <path d="M8.2 15h7.6" />
      </svg>
    ),
  },
  {
    to: '/urgent-care',
    badge: 'Same-Day',
    badgeClass: 'bg-[#F5E9F0] text-plum-600',
    iconBg: 'bg-[#F5E9F0] text-plum-600',
    name: 'Urgent Care',
    desc: 'Feel better sooner — licensed clinicians for everyday illness, today, without the waiting room.',
    cta: 'See what we treat',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 8.5v7M8.5 12h7" />
      </svg>
    ),
  },
  {
    to: '/products',
    badge: 'Formulary',
    badgeClass: 'bg-[#EDF7F7] text-teal-700',
    iconBg: 'bg-[#EDF7F7] text-[#29A19C]',
    name: 'Browse the Full Formulary',
    desc: 'Every prescription and compounded product — sexual health, hair & skin, thyroid and more — searchable in one place.',
    cta: 'Browse all',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3.5" y="3.5" width="7" height="7" rx="1.6" />
        <rect x="13.5" y="3.5" width="7" height="7" rx="1.6" />
        <rect x="3.5" y="13.5" width="7" height="7" rx="1.6" />
        <rect x="13.5" y="13.5" width="7" height="7" rx="1.6" />
      </svg>
    ),
  },
]

export function WhatWeTreat() {
  const { openBarry } = useModals()

  return (
    <section id="treatments" className="bg-white py-[104px] max-[640px]:py-14">
      <div className="hb-wrap">
        <div className="mx-auto mb-[60px] max-w-[600px] text-center max-[640px]:mb-8">
          <Reveal>
            <EyebrowLabel>What We Treat</EyebrowLabel>
            <h2 className="mt-4 font-serif text-[clamp(32px,4.2vw,50px)] font-semibold leading-[1.08] tracking-[-0.5px] text-[#191A17]">
              One platform. Your <em className="hl text-teal-600">whole</em> health picture.
            </h2>
            <p className="mx-auto mt-[18px] max-w-[600px] text-[18px] leading-[1.7] text-[#6B6B6B] max-[640px]:mt-3 max-[640px]:text-[15px]">
              Every protocol is prescribed by a licensed practitioner, compounded by a 503A pharmacy,
              and monitored by your care team.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-[22px] max-[640px]:gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {CARDS.map((card, i) => (
            <Reveal key={card.to} delay={i * 50}>
              <Link
                to={card.to}
                className="group relative flex h-full flex-col overflow-hidden rounded-[20px] border-[1.5px] border-[#E8F1F0] bg-white p-[30px_26px] shadow-[0_2px_16px_rgba(0,128,128,0.07)] transition duration-[280ms] hover:-translate-y-[7px] hover:border-transparent hover:shadow-[0_12px_40px_rgba(0,128,128,0.14)] before:absolute before:left-0 before:top-0 before:h-1 before:w-full before:origin-left before:scale-x-0 before:bg-teal-600 before:transition-transform before:duration-300 hover:before:scale-x-100 max-[640px]:p-5"
              >
                <div
                  className={`mb-[18px] inline-flex h-[54px] w-[54px] items-center justify-center rounded-[14px] max-[640px]:mb-3 max-[640px]:h-11 max-[640px]:w-11 ${card.iconBg}`}
                >
                  {card.icon}
                </div>
                <span
                  className={`mb-3 inline-flex w-fit self-start rounded-full px-[11px] py-1 font-display text-[10.5px] font-extrabold uppercase tracking-[1px] ${card.badgeClass}`}
                >
                  {card.badge}
                </span>
                <div className="mb-2 font-serif text-[20px] font-semibold text-[#191A17]">{card.name}</div>
                <p className="mb-4 min-h-[66px] flex-1 text-[13.5px] leading-[1.65] text-[#6B6B6B] max-[640px]:min-h-0">
                  {card.desc}
                </p>
                <div className="mt-auto">
                  <span className="btn btn-teal btn-sm">{card.cta}</span>
                </div>
              </Link>
            </Reveal>
          ))}

          {/* Barry card — matches 10x */}
          <Reveal delay={CARDS.length * 50}>
            <div className="relative flex h-full flex-col overflow-hidden rounded-[20px] border-transparent bg-gradient-to-br from-[#EDF7F7] to-[#F7FAE8] p-[30px_26px] shadow-[0_2px_16px_rgba(0,128,128,0.07)] max-[640px]:p-5">
              <div className="mb-[18px] inline-flex h-[54px] w-[54px] items-center justify-center rounded-[14px] bg-white text-plum-600 max-[640px]:mb-3 max-[640px]:h-11 max-[640px]:w-11">
                <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <path d="m12 15 2.5-2.5M9 11a5 5 0 1 1 6 4.9V18H9v-2.1A5 5 0 0 1 9 11Z" />
                </svg>
              </div>
              <div className="mb-2 font-serif text-[20px] font-semibold text-[#191A17]">
                Not sure where to start?
              </div>
              <p className="mb-4 min-h-[66px] flex-1 text-[13.5px] leading-[1.65] text-[#6B6B6B] max-[640px]:min-h-0">
                Let Barry match you to the right protocol in about 60 seconds — no email required to
                see your options.
              </p>
              <div className="mt-auto">
                <button type="button" onClick={openBarry} className="btn btn-berry btn-sm">
                  Find my treatment →
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
